import React, { useState , useRef, useEffect} from 'react';
import styles from './feedbackPanel.module.css';

function FeedbackPanel(){
  const [showFeedbackBox, setShowFeedbackBox] = useState(false);




  //-----------Display feedback expansion box or not---------------------
  
  const feedbackButtonRef = useRef(null);
  const feedbackExpansionBoxRef = useRef(null);


  useEffect(() => {
    function handleClickOutside(event) {
      if (feedbackExpansionBoxRef.current && !feedbackExpansionBoxRef.current.contains(event.target) && !feedbackButtonRef.current.contains(event.target)) {
        // Clicked outside the component
        //console.log('Clicked outside!');
        setShowFeedbackBox(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {                                                    //  Didn't understand what this is for.
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  //---------------------







  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');

  const handleFeedbackSubmit = (e) => {
    e.preventDefault();
    // You can handle the submission of feedback here, such as sending it to a server
    //console.log('Subject:', subject);
    //console.log('Description:', description);
    // Optionally, you can clear the input fields after submission
    setSubject('');
    setDescription('');
  };





  
  return(
    <div className={styles.feedback_panel_div}>
      <div ref={feedbackButtonRef} name="feedback" onClick={()=>setShowFeedbackBox(prev=>!prev)} className={(showFeedbackBox===true)? styles.clicked_feedback : styles.feedback}>Feedback</div>
      
      {(showFeedbackBox===true)&&(<div ref={feedbackExpansionBoxRef} className={styles.feedback_box}>
                                    <h2 style={{ marginBottom: '1.5rem' }}>Send Feedback</h2>
                                    <h4 style={{ marginBottom: '2.5rem' }}>(We read and reply to all your feedbacks.)</h4>
                                    <form onSubmit={handleFeedbackSubmit}>
                                      <input
                                        type="text"
                                        className={styles.feedback_subject}
                                        value={subject}
                                        onChange={(e) => setSubject(e.target.value)}
                                        required
                                        placeholder='Subject...'
                                      />
                                      <textarea
                                        className={styles.feedback_description}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        required
                                        rows={'20'}
                                        placeholder='Description'
                                      />
                                      <button className={styles.feedback_submit_button} type="submit">Submit Feedback</button>
                                    </form> 
                                  </div>)}
    
      <div className={styles.below_feedback_panel_div}>
        <p>Privacy</p>
        <p>.</p>
        <p>Terms</p>
        <p>.</p>
        <p>Contact Us</p>
      </div>
    </div>
  );
}

export default FeedbackPanel;